<template>
<div style="background-color: white">
  <div class="flow-create-model-wrap">

    <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="mini">

      <el-divider content-position="left">模型信息</el-divider>

      <div class="wrap-item info-wrap">

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="模型名称" prop="model_name">
              <el-input class="form-input" v-model="form.model_name" autocomplete="off" :disabled="form.is_sync == 1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据库表名" prop="model_table">
              <el-input class="form-input" v-model="form.model_table" autocomplete="off" @change="checkModelTable" :disabled="form.is_sync == 1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="模型分类" prop="category_id">
              <el-input class="form-input" v-model="form.category_id" autocomplete="off" :disabled="form.is_sync == 1"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </div>

      <el-divider content-position="left">模型字段</el-divider>

      <el-button size="mini" type="primary" @click="editField(null)" icon="el-icon-plus" :disabled="form.is_sync == 1">添加模型字段</el-button>
      <el-button size="mini" type="primary" @click="addModelChild()" icon="el-icon-plus" >添加子模型</el-button>

      <div class="wrap-item field-wrap">

        <el-table :data="form.field_json" v-loading="loading" border style="width: 100%">
          <el-table-column prop="field_name" label="字段名称" align="center"></el-table-column>
          <el-table-column prop="field_description" label="字段描述" align="center"></el-table-column>
          <el-table-column prop="type" label="字段类型" align="center"></el-table-column>
          <el-table-column prop="is_null" label="允许空值" align="center">
            <template slot-scope="scope">
              {{scope.row.is_null ? '是' : '否'}}
            </template>
          </el-table-column>
          <el-table-column prop="field_name" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" v-if="scope.row.is_edit" @click="editField(scope.row)" :disabled="form.is_sync == 1">编辑</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" v-if="scope.row.is_del" @click="removeField(scope)" :disabled="form.is_sync == 1">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>

      <div class="wrap-item opt-btns">
        <!-- <el-button type="primary" size="mini" @click="$parent.nextStep()">下一步</el-button> -->
        <!-- <el-button size="mini" type="primary" @click="saveModel()" :disabled="form.is_sync == 1">保存</el-button> -->
        <!-- <el-button size="mini" @click="resetForm()" :disabled="form.is_sync == 1">重置</el-button> -->
      </div>

    </el-form>

    <el-dialog title="编辑" :visible.sync="dialogVisibleField" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="字段描述" prop="title">
            <el-input class="form-input" v-model="editForm.field_description" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段名称" prop="title">
            <el-input class="form-input" v-model="editForm.field_name" :disabled="form.is_sync === 1" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段类型" prop="title">
<!--            <el-input class="form-input" v-model="editForm.type" :disabled="field_is_edit" autocomplete="off"></el-input>-->
            <el-select v-model="editForm.type" :disabled="form.is_sync === 1" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleField = false">取 消</el-button>
        <el-button type="primary" @click="saveField()" >确 定</el-button>
      </div>
    </el-dialog>

  </div>
  <template v-for="(item, index) in componentList">
    <KeepAlive>
      <component :parentValue="parentValue" :index="index" :is="item" v-on:getChildData="getModelChildData" ref="modelChild" />
    </KeepAlive>
  </template>

</div>
</template>

<script>

import Http from "../common/Http";
import {pinyin} from "pinyin-pro";

export default {
  name:"flow-create-model",
  props: ["value"],
  components: {
    'flow-create-model-child'   : () => import('./FlowCreateModelChild.vue'),
  },
  data () {

    let checkModelTable = (rule, value, callback) => {
      if (!value) return callback(new Error('数据库表名不能为空'));
      if(/^[a-z]+/.test(value) == false) return callback(new Error('数据库名必须以字母开头'));
      callback()
    }

    return {
      form: {},
      editForm: {},
      dialogVisibleField: false,
      activeField: null,
      field_is_edit: false,
      componentList:[],
      rules: {
        model_name: [
          { required: true, message: '请输入模型名称', trigger: 'blur' },
        ],
        model_table: [
          { required: true, validator: checkModelTable, trigger: 'blur' },
        ],
        // category_id: [
        //   { required: true, message: '请输入模型分类', trigger: 'blur' },
        // ]
      },
      loading: false,
      options: [{
        value: 'input',
        label: '输入框'
      }, {
        value: 'text',
        label: '文本'
      }, {
        value: 'date',
        label: '日期'
      }, {
        value: 'dateTime',
        label: '时间'
      }],
      parentValue: {}
    }
  },
  computed: {
    editFieldName: function () {
      return this.editForm.field_description
    },
    editModelName: function () {
      return this.form.model_name
    }
  },
  watch: {
    editFieldName: function(n) {
      let pinyinName = pinyin(n, { toneType: 'num', type: 'array' });
      this.editForm.field_name = this.checkFieldJson(pinyinName.join("_"));
    },
    editModelName: function(n) {
      let pinyinName = pinyin(n, { toneType: 'num', type: 'array' });
      this.form.model_table = pinyinName.join("_");
    },
  },
  beforeMount() {
    //this.form = this.getFormData()
    this.editForm = this.getEditFormData()
  },
  activated() {
    console.log('flow model activated')

    this.parentValue = this.value
    this.$refs.form.clearValidate();

    if(this.value.master.cache) {
      this.form = this.value.master.cache.model
    } else {
      if(this.value.model && (this.value.model.model_id > 0 || this.value.model.field_json)) {
        this.form = this.value.model
      } else {
        this.getDefaultFields( data => {
          this.form = this.getFormData()
          this.form.field_json = data
          this.value.model = this.form
        })
      }
    }

    // 判断是否存在子模型,若存在则显示子组件
    if (this.form.model_child_json !== '') {
      if (this.form.model_child_json instanceof Array) {
        for (let i=0; i<this.form.model_child_json.length; i++ ) {
          this.componentList[i] = 'flow-create-model-child';
        }
      }
    }

  },
  methods: {

    getFormData(data) {
      return Object.assign({
        model_id: 0,
        model_name: '',
        model_table: '',
        category_id: '',
        is_sync: 0,
        field_json: [],
        model_child_json:[]
      }, data)
    },

    getEditFormData(data) {
      return Object.assign({
        field_name: '',
        field_description: '',
        type: '',
        is_del: true,
        is_edit: true,
        is_null: false,
        is_show: true,
        options: [],
      }, data)
    },

    // 获取默认字段
    getDefaultFields(callback) {
      this.loading = true
      Http.post("flow/FlowModel/getDefaultFields", {}, res => {
        this.loading = false
        callback(res.data)
      })
    },

    // 修改字段
    editField(data) {
      this.field_is_edit = !!data
      this.activeField = data
      this.editForm = this.getEditFormData(data)
      this.dialogVisibleField = true
    },

    // 保存修改字段
    saveField() {
      if(this.activeField == null) {
        this.editForm.field_name = this.checkFieldJson(this.editForm.field_name)
        this.form.field_json.push(this.editForm)
      } else {
        Object.assign(this.activeField, this.editForm)
      }
      this.dialogVisibleField = false
    },

    // 移除字段
    removeField(data) {
      this.form.field_json.splice(data.$index, 1)
    },

    // 验证表单
    validate(callback) {

      this.$refs.form.validate((valid) => {
        if(valid) callback()
      });

    },

    // 检查数据库表名
    checkModelTable(callback) {

      Http.get("flow/FlowModel/checkModelTable", {model_id: this.form.model_id, model_table: this.form.model_table}, res => {
        if(res.code) {
          if(res.data.count > 0) {
            this.$message.warning('该数据库表名已存在，请重新填写')
            if(callback) callback(false)
          } else {
            if(callback) callback(true)
          }
        } else {
          this.$message.warning(res.msg)
          if(callback) callback(false)
        }
      })
    },

    addModelChild() {
      this.componentList.push('flow-create-model-child')
    },
    // 接收子组件返回的值,然后插进this.form里面
    getModelChildData(obj) {
      if (this.form.model_child_json === null) {
        this.form.model_child_json = [];
      }
      if (this.form.model_child_json[obj.index] === 'undefined') {
        this.form.model_child_json[obj.index] = [];
      }
      this.form.model_child_json[obj.index] = obj.formChild
      this.value.model = this.form
    },

    //判断字段是否重复
    checkFieldJson(fieldName) {
      let fieldList = this.form.field_json
      if (typeof fieldList === 'Array') {
        for(let i=1 ; i < fieldList.length; i++) {
          let item = fieldList[i];
          if (item.field_name === fieldName) {
            return fieldName + Date.now()
          }
        }
      }
      return fieldName;
    }

  }
}
</script>
<style lang="scss" scoped>

@import '../common.scss';

.flow-create-model-wrap {
  padding: 10px 20px;

  .wrap-item {
    padding: 10px 0;
  }

  .info-wrap {
    margin-right: 30px;

    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }

  .opt-btns {
    text-align: center;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/FlowCreateModel.vue